import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastService } from '@ui/global-shared/services';
import { markAllFormControls } from '@ui/global-shared/util/reactive-form-util';
import { TokenRenewService } from '../../services/token-renew/token-renew.service';
import { FormLabelComponent } from '@ui/global-shared/components/form-label/form-label.component';
import { Bind } from 'primeng/bind';
import { InputText } from 'primeng/inputtext';
import { FormErrorsComponent } from '@ui/global-shared/components/form-errors/form-errors.component';

import { Message } from 'primeng/message';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';

@Component({
  selector: 'pt-resend-email',
  templateUrl: './resend-email.component.html',
  styleUrls: ['./resend-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormLabelComponent,
    Bind,
    InputText,
    FormErrorsComponent,
    Message,
    PrimeTemplate,
    Button,
  ],
})
export class ResendEmailComponent implements OnInit {
  private tokenRenewService = inject(TokenRenewService);
  private formBuilder = inject(UntypedFormBuilder);
  private toaster = inject(ToastService);

  requestSuccessful = false;
  resendEmail: UntypedFormGroup;

  ngOnInit(): void {
    this.resendEmail = this.formBuilder.group({
      username: ['', Validators.required],
    });
  }

  requestNewToken(): void {
    if (!this.resendEmail.valid) {
      markAllFormControls(this.resendEmail);
      this.toaster.formErrorsToast();
      return;
    }

    this.tokenRenewService
      .renewSignup(this.resendEmail.get('username').value)
      .subscribe(() => {
        // returns true anyways
      });

    this.requestSuccessful = true;
  }
}
